var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.dynamicComponent,_vm._b({tag:"component"},'component',_vm.componentData,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }